import { cn } from "@/lib/cn";

/** Shared control surface for Input / Textarea / Select. */
export const fieldSurface =
  "w-full rounded-xl border bg-white/[0.03] px-4 text-md text-white placeholder:text-white/50 backdrop-blur-md transition-[border-color,box-shadow,background-color] duration-200 outline-none focus:bg-white/[0.05] disabled:cursor-not-allowed disabled:opacity-50";

export function fieldStateClasses(hasError?: boolean) {
  return hasError
    ? "border-danger/60 focus:border-danger focus:shadow-[0_0_0_3px_rgba(255,92,108,0.18)]"
    : "border-white/10 hover:border-white/18 focus:border-flamingo/70 focus:shadow-[0_0_0_3px_rgba(255,77,154,0.18)]";
}

export interface FieldFrameProps {
  label?: React.ReactNode;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  errorId?: string;
  required?: boolean;
  htmlFor?: string;
  className?: string;
  children: React.ReactNode;
}

/** Label + control + hint/error scaffold used by every form field. */
export function FieldFrame({
  label,
  hint,
  error,
  errorId,
  required,
  htmlFor,
  className,
  children,
}: FieldFrameProps) {
  return (
    <div className={cn("flex w-full flex-col gap-1.5", className)}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="text-sm font-medium text-white/75"
        >
          {label}
          {required && <span className="ml-0.5 text-flamingo">*</span>}
        </label>
      )}
      {children}
      {error ? (
        <p
          id={errorId}
          role="alert"
          className="text-xs font-medium text-danger-light"
        >
          {error}
        </p>
      ) : hint ? (
        <p className="text-xs text-white/55">{hint}</p>
      ) : null}
    </div>
  );
}
